/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable react/jsx-props-no-spreading */

import React, { useState } from 'react';
import { withRouter } from 'react-router';
import {
    func, object, string, array, shape, number, arrayOf, bool,
} from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import {
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
    Typography,
    Grid,
    Tab,
    Tabs,
} from '@material-ui/core';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import TabPanel from '../../../common/TabPanel';
import ModifyGiftMessage from './ModifyOrderDetails/ModifyGiftMessage';
import ModifyDate from './ModifyOrderDetails/ModifyDate';
import ModifyDateV2 from './ModifyOrderDetails/ModifyDateV2';
import ModifyOrderConfirmation from './ModifyOrderDetails/ModifyOrderConfirmation';
import customBreakpoints from '../../../../../helpers/customBreakpoints';
import configENV from '../../../config';
import { getSSRDeviceType } from '../../../../../../state/ducks/App/App-Selectors';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import ModifyRecipientAddress from './ModifyOrderDetails/ModifyRecipientAddress';
import States from '../../../state/constants/States';
import Helper from '../../../state/reducers/Helper';
import { DDMMMYY } from '../../../utils/dateString';


const { PERSIST_KEY } = configENV;

const styles = (theme) => ({
    modalTitleContainer: {
        backgroundColor: theme.palette.colorNeutral30,
        padding: 0,
        '& p': {
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign: 'center',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: '16px',
            },
        },
    },
    closeButton: {
        position: 'absolute',
        top: '5px',
        right: '10px',
        color: theme.palette.colorPrimaryAccountCtaButton,
    },
    modalContentContainer: {
        height: 'auto',
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
        paddingRight: '20px !important',
        paddingLeft: '20px !important',
        paddingBottom: '0px !important',
        // Used contains Mui class name to avoid CSS issue on Account MFE
        '& [class*="MuiBox-root"]': {
            paddingBottom: '20px',
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            height: 'auto',
        },
    },
    mmoModal: {
        // Used contains Mui class name to avoid CSS issue on Account MFE
        '& [class*="MuiDialog-paperFullWidth"]': {
            width: '700px',
            maxWidth: '800px',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                margin: '14px',
                height: '82vh',
            },
        },
    },
    imageWrap: {
        textAlign: 'center',
    },
    thankyouImage: {
        width: '273px',
    },
    closeWindow: {
        margin: '10px auto',
        width: '50%',
        backgroundColor: theme.palette.colorPrimaryAccountCtaButton,
        color: theme.palette.common.white || '#fff',
    },
    tabLabelContainer: {
        display: 'flex',
    },
    tabOrderLabel: {
        display: 'flex',
        alignItems: 'center',
    },
    tabLabel: {
        textAlign: 'left',
    },
    tabsWrap: {
        // Used contains Mui class name to avoid CSS issue on Account MFE
        '& [class*="MuiButtonBase-root"]': {
            border: `1px solid ${theme.palette.colorNeutral50}`,
            borderBottom: 'none',
            borderRadius: '5px 5px 0px 0px',
            width: '213px',
            opacity: '1',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                maxWidth: '111px',
                fontSize: '12px',
            },
            // Used contains Mui class name to avoid CSS issue on Account MFE
            '& [class*="MuiTab-wrapper"]': {
                '& span': {
                    color: theme.palette.colorPrimaryAccountCtaButton,
                    fontWeight: '600',
                    '& span': {
                        display: 'inline-block',
                        height: '22px',
                        width: '22px',
                        backgroundColor: theme.palette.colorPrimaryAccountCtaButton,
                        borderRadius: '50%',
                        marginRight: '9px',
                        fontSize: '13px',
                        color: `${theme.palette.common.white} !important`,
                        fontWeight: '400',
                        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                            height: '18px',
                            width: '18px',
                            fontSize: '10px',
                        },
                    },
                },
            },
        },
        // Used contains Mui class name to avoid CSS issue on Account MFE
        '& [class*="MuiTab-root"]': {
            padding: '0 8px',
        },
        // Used contains Mui class name to avoid CSS issue on Account MFE
        '& [class*="Mui-selected"]': {
            background: theme.palette.common.white,
            '& [class*="MuiTab-wrapper"]': {
                '& span': {
                    color: `${theme.palette.colorPrimaryAccountCtaButton} !important'`,
                    '& span': {
                        color: theme.palette.colorPrimaryAccountCtaButton,
                    },
                },
            },
        },
        // Used contains Mui class name to avoid CSS issue on Account MFE
        '& [class*="Mui-disabled"]': {
            background: theme.palette.common.white,
            '& [class*="MuiTab-wrapper"]': {
                '& span': {
                    color: `${theme.palette.common.grey} !important`,
                    '& span': {
                        backgroundColor: `${theme.palette.common.grey} !important`,
                    },
                },
            },
        },
        '& div > div > span': {
            display: 'none',
        },
    },
});

const ModifyOrder = (props) => {
    const {
        classes,
        closeMMO,
        action,
        itemDetail,
        fetchDeliveryDates,
        submitModifiedOrder,
        deliveryDatesResponse,
        ROSSOrder,
        recipient,
        responseStatus,
        ssrDeviceType,
        history,
        clearProductAvilability,
        recipientSeqNumber,
        handleSearchAddress,
        searchResults,
        searchError,
        handleSelectedAddress,
        selectedAddress,
        handleSetVerificationState,
        handleVerifyAddress,
        isAddressVerification,
        clearAddressVerification,
        promCodeFlag = false,
        modifyEligibility = {},
        featureFlags,
        ROSSOrderTotal
    } = props;
    let defaultTab = 0;
    if (action === 'editDate') {
        defaultTab = 1;
    } else if (action === 'editMsg') {
        defaultTab = 2;
    }
    const states = Helper.refactorStateData(States);
    let recipientAddressObj = {};
    const recipientProfile = ROSSOrder?.recipientProfiles?.[0];
    const addressDetail = ROSSOrder?.recipientProfiles?.[0]?.addressDetail[0];
    const addressValues = {
        1: 'Residence', 2: 'Business', 4: 'Funeral Home', 5: 'Hospital', 6: 'Apartment', 8: 'School', 9: 'APO/FPO', 10: 'P.O.Box', 11: 'Church',
    };
    const addressType = ROSSOrder?.recipientProfiles?.[0].addressDetail[0].addressType;
    recipientAddressObj = {
        firstName: recipientProfile?.firstName || '',
        lastName: recipientProfile?.lastName || '',
        locationType: addressValues[addressType] || 'Residence',
        company: recipientProfile?.businessName || '',
        addressLine1: addressDetail?.addressLine1 || '',
        addressLine2: addressDetail?.addressLine2 || '',
        addressLine3: addressDetail?.addressLine3 || '',
        cityName: addressDetail?.cityName || '',
        state: addressDetail?.state || states.US[0].id,
        zipCode: addressDetail?.zipCode || '',
        country: 'US',
        phoneNumber: recipientProfile?.phones?.[0]?.phone?.[0]?.number || '',
    };

    const selectDeliveryDate = ROSSOrder.items?.[0]?.deliveryDate;
    const fullCardMessageWithAuthor = ROSSOrder.items?.[0]?.cardMessage;
    let cardMsg = fullCardMessageWithAuthor; // i love you with all my heart!- you are the best. - wayne
    const messageLength = fullCardMessageWithAuthor.split('-').length; // i love you with all my heart!- you are the best. - wayne ==> ['i love you with all my heart!', 'you are the best. ', 'wayne'] 3
    if (fullCardMessageWithAuthor.includes('-')) {
        if (messageLength > 1) {
            cardMsg =
                fullCardMessageWithAuthor
                    .split('-') // ['i love you with all my heart!', 'you are the best. ', 'wayne']
                    .slice(0, messageLength - 1)
                    .join('-')
                    .trim()
        } else {
            cardMsg = fullCardMessageWithAuthor.split('-')[0].trim(); // To get actual gift message and not showing author name with card message
        }
    } else if (fullCardMessageWithAuthor.includes('From:')) {
        cardMsg = fullCardMessageWithAuthor.split('From:')[0].trim(); // To get actual gift message and not showing author name with card message
    }
    const cardMessage = cardMsg === 'Sender did not request a card message' || cardMsg === 'No Card Message' || cardMsg === 'No card message was provided' ? '' : cardMsg;

    let author = '';
    if (fullCardMessageWithAuthor.includes('-')) {
        if (messageLength > 1) {
            author = fullCardMessageWithAuthor.split('-')[messageLength - 1].trim();
        } else {
            author = fullCardMessageWithAuthor.split('-')[1].trim(); // To get author name from card message
        }
    } else if (fullCardMessageWithAuthor.includes('From:')) {
        author = fullCardMessageWithAuthor.split('From:')[1].trim(); // To get author name from card message
    }

    const formatNumber = (phoneNumber) => phoneNumber.replace(/[^\d]/g, '');

    const [value, setValue] = useState(defaultTab);
    const [isConfirmationScreenOn, setScreenCheck] = useState(false);
    const [modifiedRecipientAddress, setModifiedRecipientAddress] = useState(recipientAddressObj);
    const [modifiedDate, setModifiedDate] = useState(selectDeliveryDate);
    const [deliverySLA, setDeliverySLA] = useState('');
    const [modifiedDeliveryMethod, setModifiedDeliveryMethod] = useState('');
    const [modifiedGiftMsg, setModifiedGiftMsg] = useState(cardMessage);
    const [modifiedAuthor, setModifiedAuthor] = useState(author);
    const [isError, setIsError] = useState(false);

    const isDeliveryDateChanged = modifiedDate ? (DDMMMYY(selectDeliveryDate) !== DDMMMYY(modifiedDate)) : false;
    const isRecipientAddressChanged = modifiedRecipientAddress ? (JSON.stringify(recipientAddressObj) !== JSON.stringify(modifiedRecipientAddress)) : false;

    const modifiedMessage = modifiedGiftMsg?.includes('\n') ? modifiedGiftMsg.replace('\n', '').trim() : modifiedGiftMsg; // removing \n which is used for hd multiline functionality
    const isAuthorChanged = modifiedAuthor || modifiedAuthor === '' ? (author !== modifiedAuthor) : false;
    const isGiftMessageChanged = modifiedMessage !== '' && (modifiedMessage !== cardMessage || isAuthorChanged);
    const productBrand = ROSSOrder?.items?.[0]?.productBrand;
    const { isRecipientModifiable, isDeliveryDateModifiable, isCardMsgModifiable } = modifyEligibility;
    const isUsingV1DeliveryDatesEndpoint = featureFlags['is-delivery-calendar-using-v-1-endpoint'];

    const isMobile = ssrDeviceType === 'mobile';
    const sourceId = ROSSOrder?.items?.[0]?.sourceId;

    const handleChange = (event, newValue) => {
        if (isRecipientModifiable === false && newValue === 0) return;
        if (isDeliveryDateModifiable === false && newValue === 1) return;
        if (isCardMsgModifiable === false && newValue === 2) return;
        setValue(newValue);
    };

    const checkForConfirmationScreen = (boolVal) => {
        setScreenCheck(boolVal);
    };
    const getModifiedRecipientAddress = (updatedAddress) => {
        setModifiedRecipientAddress({ ...updatedAddress, phoneNumber: formatNumber(updatedAddress.phoneNumber) });
    };
    const getModifiedDeliveryMethod = (updatedMethod) => {
        setModifiedDeliveryMethod(updatedMethod);
    };
    const getModifiedGiftMsg = (updatedGiftMsg, updatedAuthor) => {
        setModifiedGiftMsg(updatedGiftMsg);
        setModifiedAuthor(updatedAuthor);
        if (cardMessage === '' && updatedGiftMsg === '') setModifiedAuthor(''); // remove this if we are going with the remove message functionality, pushed those changes into another branch
    };
    const getIsRecipientFormValid = (error) => { // To disable calendar and gift message tabs if recipient form has errors
        setIsError(error);
    };
    const a11yProps = (index) => ({
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    });

    const generateTabsLabel = (order, label) => (
        <div className={classes.tabLabelContainer}>
            <span className={classes.tabOrderLabel}>
                <span>{order}</span>
            </span>
            <span className={classes.tabLabel}>
                {label}
            </span>
        </div>
    );
    return (
        <Dialog fullWidth open maxWidth="sm" name="mmo-modal" className={classes.mmoModal}>
            <DialogTitle className={classes.modalTitleContainer}>
                <Typography>
                    <p>MODIFY MY ORDER</p>
                </Typography>
                <IconButton
                    aria-label="close-modal"
                    className={classes.closeButton}
                    size="small"
                    onClick={() => {
                        closeMMO();
                        history.go();
                    }}
                    edge="end"
                >
                    <CloseIcon />
                </IconButton>
                {!isConfirmationScreenOn && (
                    <Grid container justify="center" direction="flex-end" className={classes.tabsWrap}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="modify-order-tabs"
                        >
                            <Tab label={generateTabsLabel('1', 'Recipient')} {...a11yProps(0)} disabled={!isRecipientModifiable} />
                            <Tab label={generateTabsLabel('2', 'Delivery Dates')} {...a11yProps(1)} disabled={!isDeliveryDateModifiable || isError} />
                            <Tab label={generateTabsLabel('3', 'Gift Message')} {...a11yProps(2)} disabled={!isCardMsgModifiable || isError} />
                        </Tabs>
                    </Grid>
                )}
            </DialogTitle>
            <DialogContent className={classes.modalContentContainer}>
                {!isConfirmationScreenOn
                    ? (
                        <>
                            <TabPanel value={value} index={0}>
                                <ModifyRecipientAddress
                                    featureFlags={featureFlags}
                                    recipientAddressObj={isRecipientAddressChanged ? modifiedRecipientAddress : recipientAddressObj}
                                    getModifiedRecipientAddress={getModifiedRecipientAddress}
                                    changeTabs={setValue}
                                    isMobile={isMobile}
                                    productBrand={productBrand}
                                    handleSearchAddress={handleSearchAddress}
                                    searchResults={searchResults}
                                    searchError={searchError}
                                    handleSelectedAddress={handleSelectedAddress}
                                    selectedAddress={selectedAddress}
                                    getIsRecipientFormValid={getIsRecipientFormValid}
                                    handleSetVerificationState={handleSetVerificationState}
                                    handleVerifyAddress={handleVerifyAddress}
                                    isAddressVerification={isAddressVerification}
                                    clearAddressVerification={clearAddressVerification}
                                    currentTab={value}
                                    modifyEligibility={modifyEligibility}
                                    checkForConfirmationScreen={checkForConfirmationScreen}
                                    productType={ROSSOrder.type}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                {
                                    isUsingV1DeliveryDatesEndpoint ? (
                                        <ModifyDate
                                            fetchDeliveryDates={fetchDeliveryDates}
                                            deliveryDatesResponse={deliveryDatesResponse}
                                            ROSSOrder={ROSSOrder}
                                            recipient={recipient}
                                            itemDetail={itemDetail}
                                            setModifiedDate={setModifiedDate}
                                            getModifiedDeliveryMethod={getModifiedDeliveryMethod}
                                            responseStatus={responseStatus}
                                            originalDate={selectDeliveryDate}
                                            modifiedDate={isDeliveryDateChanged ? modifiedDate : selectDeliveryDate}
                                            changeTabs={setValue}
                                            isRecipientAddressChanged={isRecipientAddressChanged}
                                            modifiedRecipientAddress={modifiedRecipientAddress}
                                            clearProductAvilability={clearProductAvilability}
                                            promCodeFlag={promCodeFlag}
                                            modifyEligibility={modifyEligibility}
                                            checkForConfirmationScreen={checkForConfirmationScreen}
                                        />
                                    ) : (
                                        <ModifyDateV2
                                            ROSSOrder={ROSSOrder}
                                            locationType={addressValues[addressType]}
                                            originalDate={selectDeliveryDate}
                                            isRecipientAddressChanged={isRecipientAddressChanged}
                                            modifiedRecipientAddress={modifiedRecipientAddress}
                                            modifyEligibility={modifyEligibility}
                                            setDeliverySLA={setDeliverySLA}
                                            changeTabs={setValue}
                                            checkForConfirmationScreen={checkForConfirmationScreen}
                                            modifiedDate={modifiedDate}
                                            setModifiedDate={setModifiedDate}
                                        />
                                    )
                                }
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <ModifyGiftMessage
                                    giftMessage={isGiftMessageChanged ? modifiedGiftMsg : cardMessage}
                                    authorName={isAuthorChanged ? modifiedAuthor : author}
                                    checkForConfirmationScreen={checkForConfirmationScreen}
                                    getModifiedGiftMsg={getModifiedGiftMsg}
                                    changeTabs={setValue}
                                    isMobile={isMobile}
                                    productBrand={productBrand}
                                    modifyEligibility={modifyEligibility}
                                    featureFlags={featureFlags}
                                />
                            </TabPanel>
                        </>
                    )
                    : (
                        <ModifyOrderConfirmation
                            submitModifiedOrder={submitModifiedOrder}
                            checkForConfirmationScreen={checkForConfirmationScreen}
                            modifiedRecipientAddress={modifiedRecipientAddress}
                            modifiedDate={modifiedDate}
                            modifiedDeliveryMethod={modifiedDeliveryMethod?.deliverySLA}
                            modifiedGiftMsg={(cardMessage !== '' && !isGiftMessageChanged) ? cardMessage : modifiedGiftMsg}
                            modifiedAuthor={modifiedAuthor}
                            closeMMO={closeMMO}
                            ROSSOrder={ROSSOrder}
                            deliverySLA={deliverySLA}
                            getBackToDeliveryDate={setValue}
                            isDeliveryDateChanged={isDeliveryDateChanged}
                            isRecipientAddressChanged={isRecipientAddressChanged}
                            isGiftMessageChanged={isGiftMessageChanged}
                            isAuthorChanged={isAuthorChanged}
                            isMobile={isMobile}
                            recipientSeqNumber={recipientSeqNumber}
                            modifyEligibility={modifyEligibility}
                            changeTabs={setValue}
                            promCodeFlag={promCodeFlag}
                            isUsingCheckoutGiftMessageForm={featureFlags?.['is-using-checkout-gift-message-form'] || false}
                            modifiedDeliveryDateSurcharge={modifiedDeliveryMethod?.surcharges}
                            ROSSOrderTotal={ROSSOrderTotal}
                            sourceId={sourceId}
                            isUsingV1DeliveryDatesEndpoint={isUsingV1DeliveryDatesEndpoint}
                        />
                    )}
            </DialogContent>
        </Dialog>
    );
};

ModifyOrder.propTypes = {
    classes: object.isRequired,
    closeMMO: func.isRequired,
    action: string.isRequired,
    itemDetail: array.isRequired,
    fetchDeliveryDates: func.isRequired,
    deliveryDatesResponse: shape({
        deliveryDates: array.isRequired,
    }).isRequired,
    ROSSOrder: object.isRequired,
    recipient: object.isRequired,
    submitModifiedOrder: func.isRequired,
    responseStatus: number.isRequired,
    ssrDeviceType: string.isRequired,
    ROSSModifyOrder: string.isRequired,
    history: object.isRequired,
    go: func.isRequired,
    clearProductAvilability: func.isRequired,
    recipientSeqNumber: string.isRequired,
    handleSearchAddress: func.isRequired,
    handleSelectedAddress: func.isRequired,
    selectedAddress: shape({
        street: string,
        apt: string,
        city: string,
        state: string,
        country: string,
        zipcode: string,
    }).isRequired,
    searchResults: arrayOf(
        shape({
            suggestion: string,
            matched: array,
            format: string,
        }).isRequired,
    ).isRequired,
    searchError: object.isRequired,
    isAddressVerification: bool.isRequired,
    handleSetVerificationState: func.isRequired,
    handleVerifyAddress: func.isRequired,
    clearAddressVerification: func.isRequired,
    promCodeFlag: bool.isRequired,
    modifyEligibility: shape({
        isRecipientModifiable: bool,
        isDeliveryDateModifiable: bool,
        isCardMsgModifiable: bool,
    }).isRequired,
    featureFlags: shape({
        'is-using-checkout-gift-message-form': bool.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    let searchResults = [];
    let selectedAddress = {};
    let searchError = { Message: '' };
    let isAddressVerification = false;
    try {
        ({
            searchResults, searchError, selectedAddress, isAddressVerification,
        } = newState.common.addressVerification);
    } catch (ex) {
        // continue regardless of error
    }
    return {
        deliveryDatesResponse: newState.deliveryDatesResponse,
        responseStatus: newState.responseStatus,
        ssrDeviceType: getSSRDeviceType(state),
        searchResults,
        searchError,
        selectedAddress,
        isAddressVerification,
        featureFlags: getFeatureFlags(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchDeliveryDates: (payload) => dispatch(EventDispatcher.handleFetchDeliveryDates(payload)),
    submitModifiedOrder: (payload) => dispatch(EventDispatcher.submitModifiedOrder(payload)),
    clearProductAvilability: () => dispatch(EventDispatcher.clearProductAvilabilityRequest()),
    handleSearchAddress: (params) => dispatch(EventDispatcher.handleSearchAddress(params)),
    handleSelectedAddress: (address) => dispatch(EventDispatcher.handleSelectAnAddress(address)),
    handleSetVerificationState: (isVerified) => dispatch(EventDispatcher.handleSetVerificationState(isVerified)),
    handleVerifyAddress: (params) => dispatch(EventDispatcher.handleVerifyAddress(params)),
    clearAddressVerification: () => dispatch(EventDispatcher.handleClearAddressVerification()),
});

const StyledModifyOrder = withStyles(styles)(ModifyOrder);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StyledModifyOrder));
